import { useState } from 'react';
import { rankings } from '@/mocks/rankings';
import { hotWords } from '@/mocks/voices';

const tabs = ['本周', '本月'];

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-secondary-500',
  flat: 'ri-subtract-line text-foreground-400',
};

export default function RankBoard() {
  const [tab, setTab] = useState('本周');
  const list = tab === '本周' ? rankings.week : rankings.month;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center justify-between gap-3">
        <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
          <i className="ri-bar-chart-2-line text-lg text-primary-500" />
          争议指数榜
        </h3>
        <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
          {tabs.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setTab(item)}
              className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                tab === item ? 'bg-foreground-950 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>

      <ol className="mt-5 flex flex-col gap-4">
        {list.map((item, index) => (
          <li key={item.id} className="flex items-start gap-3">
            <span
              className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded font-heading text-xs font-bold ${
                index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
              }`}
            >
              {index + 1}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-start justify-between gap-2">
                <p className="text-[13px] font-medium leading-snug text-foreground-900">{item.name}</p>
                <span className="flex shrink-0 items-center gap-1 font-heading text-sm font-bold text-foreground-950">
                  {item.score}
                  <i className={`${trendIcon[item.trend]} text-xs`} />
                </span>
              </div>
              <div className="mt-2 flex items-center gap-2">
                <span className="h-1 flex-1 overflow-hidden rounded-full bg-background-200">
                  <span
                    className="block h-full origin-left animate-grow-bar rounded-full bg-primary-400"
                    style={{ width: `${item.score}%` }}
                  />
                </span>
                <span className="shrink-0 rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-900">
                  {item.tag}
                </span>
              </div>
            </div>
          </li>
        ))}
      </ol>

      <div className="mt-6 border-t border-background-200 pt-5">
        <p className="text-[11px] font-medium uppercase tracking-[0.2em] text-foreground-500">近期热词</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {hotWords.map((word) => (
            <span
              key={word}
              className="cursor-pointer rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900 transition-colors hover:bg-accent-200"
            >
              {word}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}